/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.FloorLocation {
  "use strict";

  export class FloorLocationContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
      protected INVENTORY_FLOORLOCATION_FIELD_STATUS: string;
    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

      this.baseEndpoint = appSettings.API_ENDPOINTS.floorLocation;
      this.sectionTemplatePath = "app/plugins/floorLocation/sectionViews/";
      this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_FLOORLOCATION_TAB_MAIN);
      this.entityType = "FloorLocation";
      this.INVENTORY_FLOORLOCATION_FIELD_STATUS = this.securityKeys.INVENTORY_FLOORLOCATION_FIELD_STATUS;
    }

    initializeSections(): void {
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INVENTORY_FLOORLOCATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new MainSection(0, "SECTION_FLOORLOCATION_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.floorLocation, "",
            this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.FloorLocation, null, this.securityKeys.INVENTORY_FLOORLOCATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
      }
    }

    initializeHeader(model: any): void {
      this.headerContent = model.displayName;
    }
  }
}